/**
 * What the recycle bin says when a restore is refused.
 *
 * The backend's restore-items refuses a chat board whose chat already has a live board,
 * with BadRequest `data.code: 'CHAT_BOARD_EXISTS'` (+ `existingBoardId`) and a message
 * written for the user ("A board for this chat already exists ("…"). Delete it to
 * restore this one.") — show that. Anything else keeps the generic line.
 */
export function restoreFailureMessage(error: unknown, count: number): string {
    const body = (error as { data?: { message?: unknown; data?: { code?: unknown } } } | undefined)?.data;
    if (body?.data?.code === 'CHAT_BOARD_EXISTS' && typeof body.message === 'string' && body.message) {
        return body.message;
    }
    return `Failed to restore ${count} items`;
}
